import styled from "styled-components";

const StyledChatMessages = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px 10px 16px 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  scroll-behavior: smooth;
  border-radius:20px;
  color: white;
  @media (max-width: 768px) {
    padding: 12px 8px 12px 12px;
  }
  
  @media (max-width: 480px) {
    padding: 8px 6px 8px 8px;
  }
  
  /* Ensure proper scrolling for long markdown content */
  scroll-padding-bottom: 20px;
  
  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(102, 126, 234, 0.3);
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: rgba(102, 126, 234, 0.5);
  }
  
  .message {
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
    animation: messageSlideIn 0.3s ease-out;
    width: 100%;
    
    /* Ensure proper handling of long content */
    word-break: break-word;
    overflow-wrap: break-word;
  }

  @keyframes messageSlideIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  .message-content {
    
    padding: 16px 20px;
    border-radius: 20px;
    word-wrap: break-word;
    line-height: 1.5;
    font-size: 14px;
    position: relative;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    
    /* Ensure proper text rendering for markdown */
    white-space: pre-wrap;
    overflow-wrap: break-word;
    
    /* Better handling of long content */
     min-height: fit-content;
    max-width: 100%;
  }

  /* Thinking (processing) skeleton bubble */
  .thinking-bubble {
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: fit-content;
    max-width: 85%;
    list-style: none;
  }

  .thinking-head {
    display: flex;
    align-items: center;
    gap: 8px;
    opacity: 0.95;
  }

  .thinking-head .avatar {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.22);
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.28);
    font-size: 10px;
  }

  .thinking-head .label {
    font-weight: 600;
    font-size: 12px;
    white-space: nowrap;
  }

  .thinking-lines { 
    display: flex; 
    flex-direction: column; 
    gap: 5px;
    list-style: none;
  }

  .thinking-lines .line {
    height: 8px;
    border-radius: 4px;
    background: linear-gradient(90deg, rgba(255,255,255,0.18) 25%, rgba(255,255,255,0.38) 37%, rgba(255,255,255,0.18) 63%);
    background-size: 400% 100%;
    animation: shimmer 1.2s ease-in-out infinite;
    list-style: none;
    width: 120px; /* Default width since you removed the width classes */
    position: relative;
    overflow: hidden;
  }

  /* Remove any pseudo-elements that might create dots */
  .thinking-lines .line::before,
  .thinking-lines .line::after {
    display: none;
  }

  .thinking-lines .w-95 { width: 180px; }
  .thinking-lines .w-90 { width: 160px; }
  .thinking-lines .w-80 { width: 140px; }
  .thinking-lines .w-70 { width: 120px; }
  .thinking-lines .w-60 { width: 100px; }
  .thinking-lines .w-40 { width: 80px; }

  @keyframes shimmer {
    0% { background-position: 100% 0; }
    100% { background-position: -100% 0; }
  }
  
  .message.assistant {
    align-items: flex-start;
    align-self: flex-start;
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  
  .message.assistant .message-content {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border-bottom-left-radius: 6px;
    margin-right: auto;
    margin-left: 8px;
    align-self: flex-start;
    border: none;
     /* allow near-full width while keeping tails/padding */
    
    /* Ensure proper markdown rendering */
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    
    /* Handle long content better */
    word-break: break-word;
    overflow-wrap: break-word;
    
    &::before {
      content: '';
      position: absolute;
      left: -8px;
      bottom: 0;
      width: 0;
      height: 0;
      border: 8px solid transparent;
      border-right-color: #667eea;
      border-bottom: none;
      border-left: none;
    }
  }
  
  .message.user {
    align-items: flex-end;
    align-self: flex-end;
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  
  .message.user .message-content {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    color: white;
    border-bottom-right-radius: 6px;
    margin-left: auto;
    margin-right: 8px;
    align-self: flex-end;
    border: none;
    
    text-align: left;
    
    &::after {
      content: '';
      position: absolute;
      right: -8px;
      bottom: 0;
      width: 0;
      height: 0;
      border: 8px solid transparent;
      border-left-color: #10b981;
      border-bottom: none;
      border-right: none;
    }
  }

  .message.error .message-content {
    background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
    color: white;
    border-bottom-left-radius: 6px;
    margin-right: auto;
    margin-left: 0;
    align-self: flex-start;
    border: none;
  }
  
  .message-time {
    font-size: 11px;
    color: #64748b;
    margin-top: 6px;
    font-weight: 500;
  }
  
  .message.assistant .message-time {
    align-self: flex-start;
    margin-left: 4px;
  }

  .message.user .message-time {
    align-self: flex-end;
    margin-right: 4px;
  }

  /* Markdown styling for assistant messages */
  .message.assistant .message-content {
    /* Ensure proper spacing for markdown elements */
    & h1, & h2, & h3, & h4, & h5, & h6 {
      margin: 0.5em 0 0.3em 0;
      font-weight: 600;
      line-height: 1.3;
      color: white;
    }

    & h1 { font-size: 1.3em; }
    & h2 { font-size: 1.2em; }
    & h3 { font-size: 1.1em; }
    & h4, & h5, & h6 { font-size: 1em; }

    & p {
      margin: 0.5em 0;
      line-height: 1.5;
      color: white;
    }

    & ul, & ol {
      margin: 0.5em 0;
      padding-left: 1.5em;
      color: white;
    }

    & li {
      margin: 0.2em 0;
      line-height: 1.4;
      color: white;
    }

    & strong, & b {
      font-weight: 700;
      color: white;
    }

    & em, & i {
      font-style: italic;
      color: white;
    }

    & code {
      background: rgba(255, 255, 255, 0.2);
      padding: 0.2em 0.4em;
      border-radius: 4px;
      font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
      font-size: 0.9em;
      color: white;
    }

    & pre {
      background: rgba(255, 255, 255, 0.1);
      padding: 0.8em;
      border-radius: 8px;
      overflow-x: auto;
      margin: 0.8em 0;
      border: 1px solid rgba(255, 255, 255, 0.2);
    }

    & pre code {
      background: none;
      padding: 0;
      border-radius: 0;
    }

    & blockquote {
      border-left: 3px solid rgba(255, 255, 255, 0.4);
      margin: 0.8em 0;
      padding-left: 1em;
      font-style: italic;
      opacity: 0.9;
      color: white;
    }

    & hr {
      border: none;
      border-top: 1px solid rgba(255, 255, 255, 0.3);
      margin: 1em 0;
      color: white;
    }

    & table {
      border-collapse: collapse;
      width: 100%;
      margin: 0.8em 0;
      font-size: 0.9em;
    }

    & th, & td {
      border: 1px solid rgba(255, 255, 255, 0.3);
      padding: 0.5em;
      text-align: left;
      color: white;
    }

    & th {
      background: rgba(255, 255, 255, 0.1);
      font-weight: 600;
    }

    /* Handle long content better */
    & > *:first-child {
      margin-top: 0;
    }

    & > *:last-child {
      margin-bottom: 0;
    }

    /* Ensure proper spacing between markdown elements */
    & > * + * {
      margin-top: 0.5em;
    }

    /* Handle inline code better */
    & code:not(pre code) {
      background: rgba(255, 255, 255, 0.15);
      padding: 0.1em 0.3em;
      border-radius: 3px;
      font-size: 0.85em;
      font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
    }

    /* Better list styling */
    & ul, & ol {
      margin: 0.5em 0;
      padding-left: 1.25em;
      list-style-position: outside;
      color: white;
    }

    & ol { list-style-type: decimal; }
    & ul { list-style-type: disc; }

    /* Prevent paragraph-wrapped list items from breaking to a new line after the marker */
    & li > p { margin: 0.2em 0; }

    & li {
      margin: 0.3em 0;
      line-height: 1.4;
      color: white;
      padding-left: 0.25em;
      text-indent: 0;
    }

    & li > ul, & li > ol {
      margin: 0.3em 0 0.3em 0;
      padding-left: 1.25em;
      list-style-position: inside;
    }

    /* Better table styling */
    & table {
      border-collapse: collapse;
      width: 100%;
      margin: 0.8em 0;
      font-size: 0.9em;
      border-radius: 6px;
      overflow: hidden;
    }

    & th, & td {
      border: 1px solid rgba(255, 255, 255, 0.3);
      padding: 0.6em;
      text-align: left;
      color: white;
    }

    & th {
      background: rgba(255, 255, 255, 0.15);
      font-weight: 600;
      text-transform: uppercase;
      font-size: 0.8em;
      letter-spacing: 0.5px;
    }

    & tr:nth-child(even) {
      background: rgba(255, 255, 255, 0.05);
    }

    /* Additional improvements for better content flow */
    & > * {
      max-width: 100%;
      overflow-wrap: break-word;
      word-break: break-word;
    }

    /* Better handling of nested content */
    & * {
      color: inherit;
    }

    /* Ensure proper spacing for complex markdown */
    & > div {
      margin: 0.5em 0;
    }
  }

  .typing-indicator {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    margin-left: 6px;
    padding: 4px 8px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 8px;
    backdrop-filter: blur(4px);
  }

  .typing-indicator .dot {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.9);
    animation: typing 1.2s infinite ease-in-out;
  }

  .typing-indicator .dot:nth-child(1) {
    animation-delay: -0.24s;
  }

  .typing-indicator .dot:nth-child(2) {
    animation-delay: -0.12s;
  }

  .typing-indicator .dot:nth-child(3) {
    animation-delay: 0s;
  }

  @keyframes typing {
    0%, 80%, 100% {
      transform: scale(0.6);
      opacity: 0.4;
    }
    40% {
      transform: scale(1);
      opacity: 1;
    }
  }

  .processing-spinner {
    display: inline-flex;
    align-items: center;
    padding: 4px;
    flex-shrink: 0;
    filter: drop-shadow(0 0 8px rgba(255, 255, 255, 0.3));
  }

  .processing-spinner svg {
    filter: brightness(0) invert(1);
    opacity: 0.9;
  }

  .message.processing .message-content {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    color: white !important;
    border: none !important;
    border-radius: 20px !important;
    padding: 16px 20px !important;
    margin-bottom: 8px;
    line-height: 1.5;
    opacity: 0.95;
    display: flex !important;
    align-items: center !important;
    gap: 12px !important;
    min-height: 24px !important;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3) !important;
    font-weight: 500 !important;
    animation: processing-pulse 2s ease-in-out infinite;
    transition: all 0.3s ease !important;
  }

  .message.processing .message-content:hover {
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4) !important;
    transform: translateY(-1px) !important;
  }

  .message.processing .message-content > *:first-child {
    flex: 1;
  }

  @keyframes processing-pulse {
    0%, 100% {
      transform: scale(1);
      opacity: 0.95;
    }
    50% {
      transform: scale(1.02);
      opacity: 1;
    }
  }

  .welcome-message {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
  }

  .welcome-content {
    text-align: center;
    max-width: 280px;
    background: white;
    padding: 32px 24px;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    border: 1px solid rgba(102, 126, 234, 0.1);
  }

  .welcome-icon {
    font-size: 48px;
    margin-bottom: 16px;
    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
  }

  .welcome-content h3 {
    color: #1e293b;
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 12px;
    margin-top: 0;
  }

  .welcome-content p {
    color: #64748b;
    font-size: 14px;
    line-height: 1.6;
    margin-bottom: 24px;
  }

  .suggestions {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .suggestion-btn {
    background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
    border: 1px solid #cbd5e1;
    border-radius: 12px;
    padding: 12px 16px;
    font-size: 13px;
    color: #475569;
    cursor: pointer;
    transition: all 0.3s ease;
    text-align: left;
    font-weight: 500;
    
    &:hover {
      background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);
      border-color: #94a3b8;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
    
    &:active {
      transform: translateY(0);
    }
  }
`;

const StyledChatInterface = styled.div`
  position: fixed;
  bottom: 0;
  right: 50px;                 /* ✅ shift slightly left */
  width: 365px;
  background: #fff;
  border-radius: 20px 20px 0 0;
  z-index: 1000;
  box-shadow: 0 4px 16px rgba(0,0,0,0.1);

  animation: slideInUp 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  @keyframes slideInUp {
    from {
      opacity: 0;
      transform: translateY(20px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  /* tablet */
  @media (max-width: 768px) {
    width: calc(100vw - 48px);
    height: calc(100vh - 140px);
    max-height: 80vh;
    bottom: 90px;
    left: 24px;
    right: 24px;
    border-radius: 16px;
  }

  /* mobile */
  @media (max-width: 480px) {
    width: calc(100vw - 24px);
    height: calc(100vh - 120px);
    max-height: 85vh;
    bottom: 80px;
    left: 12px;
    right: 12px;
    border-radius: 12px;
  }
`;



const StyledChatHeader = styled.div`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  position: relative;
  
  @media (max-width: 768px) {
    padding: 16px 20px;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
  }
  
  @media (max-width: 480px) {
    padding: 12px 16px;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }
  
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  }
  
  .chat-title {
    font-weight: 700;
    font-size: 18px;
    display: flex;
    align-items: center;
    gap: 8px;
    
    &::before {
      content: '🤖';
      font-size: 20px;
    }
  }
  
  .new-chat-btn {
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.3);
    color: white;
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);
    
    @media (max-width: 768px) {
      padding: 6px 12px;
      font-size: 12px;
      border-radius: 16px;
    }
    
    @media (max-width: 480px) {
      padding: 4px 8px;
      font-size: 11px;
      border-radius: 14px;
    }
    
    &:hover {
      background: rgba(255, 255, 255, 0.3);
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    }
  }
  
  .close-btn {
    background: rgba(255, 255, 255, 0.2);
    border: none;
    color: white;
    cursor: pointer;
    font-size: 18px;
    padding: 8px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);
    
    @media (max-width: 768px) {
      width: 28px;
      height: 28px;
      font-size: 16px;
      padding: 6px;
    }
    
    @media (max-width: 480px) {
      width: 24px;
      height: 24px;
      font-size: 14px;
      padding: 4px;
    }
    
    &:hover {
      background: rgba(255, 255, 255, 0.3);
      transform: rotate(90deg);
    }
  }
`;
export { StyledChatMessages, StyledChatInterface, StyledChatHeader };
